<template>
  <div>
    <div ref="selectcontainer" class="">
      <v-select
        ref="select"
        v-model="listProduct"
        :disabled="disabled"
        :multiple="isMultiple"
        :placeholder="placeHolderSearch"
        :options="optionSearch"
        label="name"
        :clearable="true"
        :selectable="(option) => selectableProduct(option)"
        :filterable="false"
        style="background-color: white"
        :clear-search-on-blur="clearSearchSub"
        @search="searchProduct"
        @input="onSelectProduct"
        @open="onOpen"
        @close="onClose"
      >
        <!-- :calculate-position="withPopper" -->
        <!-- :filter="filterSearch" -->
        <div slot="no-options">
          <span>{{ checkNodata ? messNoOption : messPlaceHolderOption }}</span>
        </div>
        <template slot="option" slot-scope="option">
          <div class="container-option">
            <div v-if="!option.image" class="container-option-0">
              <img class="img" src="~assets/image-placeholder.png" />
            </div>
            <div v-if="option.image" v-lazyload class="container-option-0">
              <img v-if="option.image" class="img" :data-url="option.image" />
            </div>

            <div class="container-option-1">
              <div class="ml-5 is-flex is-flex-direction-column">
                <div class="is-flex">
                  <b class="is-break-words">{{ option.name }}</b>
                  <div style="margin-left: 5px">
                    <span
                      v-if="showType && option.type.name === 'wine_bundle'"
                      class="badge__search"
                      style="padding: 2px 4px"
                      >{{
                        option.type.name === "wine"
                          ? "Wine"
                          : option.type.name === "wine_bundle"
                          ? "Bundle"
                          : null
                      }}</span
                    >
                  </div>
                </div>
                <!-- <b class="is-break-words">{{option.name}}</b> -->
                <span v-if="isShowID" class="color-blur">
                  #{{ option.id }}
                </span>
              </div>
            </div>
            <div class="container-option-2">
              <div
                class="is-flex is-flex-direction-column is-align-items-flex-end"
              >
                <div v-if="isShowPrice" class="is-flex is-align-items-center">
                  <span
                    v-if="option.is_sale_off === 1"
                    class="price-sale price-sale__custom mr-5"
                  >
                    {{ currency && currency.text ? currency.text.symbol : "" }}
                    {{ formatPrice(option.original_price) }}
                  </span>
                  <span>
                    {{ currency && currency.text ? currency.text.symbol : "" }}
                    {{ formatPrice(option.price) }}
                  </span>
                </div>

                <div>
                  <span v-if="isShowStock" class="color-blur">
                    <span>Stock: </span>
                    <span
                      :style="option.units_in_stock == 0 ? 'color: red;' : null"
                    >
                      {{ displayStock(option.units_in_stock) }}</span
                    >
                  </span>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template #open-indicator="{ attributes }">
          <span v-bind="attributes" class="dp-contents">
            <i :class="iconSearch" aria-hidden="true" />
          </span>
        </template>
        <template #list-footer>
          <div
            v-if="hasInfinity"
            ref="load"
            class="has-text-centered is-flex is-justify-content-center is-align-items-center"
          >
            <i class="fa fa-spinner fa-pulse mr-5" /> <span>Loading ...</span>
          </div>
        </template>
      </v-select>
    </div>
  </div>
</template>
<script>
  // HOW TO USE
  // - import component
  // - 'result' is result search
  // - 'placeHolderSearch' is string, placeHolder default
  // - 'filter' is filter to call api
  // --- Example ---
  // <search-component
  //             : arrResult.sync="listSearch" =>  singleSearch = false
  //             : result.sync="productSearch" => singleSearch = true
  //             : placeHolderSearch="'Enter a keyword to search'"
  //             : filter="filtersSearch"
  //             : iconSearch="'fa fa-search'"
  //             : singleSearch="false"
  //             : isShowPrice="true"
  //             : isShowStock="false"
  //             : isShowID="false"
  //              @input      =>> return item when selected
  // ></search-component>
  // Product default -> data o day tuong duong page = 1
  // Khi tu search sang infinite -> gan list product = default page 1 -> page  = 1 -> load tiep page 2
  import mixin from "components/mixin";
  import { setting, product } from "api";
  import _ from "lodash";
  export default {
    name: "SearchProduct",
    mixins: [mixin],
    components: {},
    props: {
      listcompare: {
        type: Array,
        default: () => [],
      },
      arrResult: Array,
      result: [Array, Object],
      resultMultiple: Array,
      placeHolderSearch: {
        type: String,
        default: "Enter Product Name or ID to search.",
      },
      iconSearch: {
        type: String,
        default: "fa fa-search",
      },
      messNoOption: {
        type: String,
        default: "No products matched your search.",
      },
      messPlaceHolderOption: {
        type: String,
        default: "Enter Product Name or ID to search.",
      },
      filter: {
        type: Object,
        default: function () {
          return {
            // order: "desc",
            // only: "",
            // sort: "id",
            // category: "",
            // q: ""
            is_active: 1,
            q: "",
          };
        },
      },
      isSelectOutStock: {
        type: Boolean,
        default: true,
      },
      selectable: {
        type: [Boolean, Function],
        default: true,
      },
      isShowID: {
        type: Boolean,
        default: true,
      },
      isShowPrice: {
        type: Boolean,
        default: true,
      },
      isShowStock: {
        type: Boolean,
        default: true,
      },
      singleSearch: {
        type: Boolean,
        default: false,
      },
      addFirst: {
        type: Boolean,
        default: false,
      },
      isMultiple: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      showType: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        // result: [],
        listProduct: [], //v-model select
        productsSearch: [], //list result
        products: [], // list option to search
        productsDefault: [],
        checkNodata: false,
        currency: "",
        filterDefault: { ...this.filter, limit: 10, page: 1 },
        total: "",
        isInfiniteScroll: true,
        observer: null,
        searchString: "",
        isLast: false,
      };
    },
    watch: {
      listcompare: {
        handler(newVal) {
          // Assign list product for comparison to disable
          // if (newVal.length !== 0) {
          this.productsSearch = newVal;
          // }
        },
        immediate: true,
        deep: true,
      },
      result: {
        handler(newVal) {
          this.initData();
        },
        immediate: true,
        deep: true,
      },
      filter: {
        handler(newVal) {
          this.filterDefault = { ...this.filterDefault, ...newVal };
        },
        immediate: true,
        deep: true,
      },
    },
    beforeDestroy() {
      this.observer.disconnect();
    },
    methods: {
      displayStock(stock) {
        if (stock == null || stock == undefined) return;
        const result = parseInt(stock);
        return result > 0 ? this.formatNumberWithCommas(result) : result < 0 ? "∞" : "0";
      },
      initData() {
        if (this.singleSearch) {
          this.listProduct = this.result ? this.result : null;
        }
        if (this.isMultiple && this.singleSearch) {
          this.listProduct = this.result ? [...this.result] : null;
        }
        if (!this.singleSearch) {
          // this.productsSearch = this.result ? this.result : []
        }
      },
      withPopper(dropdownList, component, { width }) {},
      selectableProduct(option) {
        let result = true;
        // Check can select if product is out stock
        if (!this.isSelectOutStock && option.status.includes("out_of_stock")) {
          return false;
        }
        if (!this.selectable) return true;
        this.productsSearch.map((k) => {
          if (option.id == k.id) {
            result = false;
          }
          if (
            !this.isSelectOutStock &&
            option.status.includes("out_of_stock")
          ) {
            result = false;
          }
        });
        return result;
      },
      clearSearchSub(data) {
        return !data.clearSearchOnSelect && !data.multiple;
      },
      async searchProduct(text, loading) {
        this.searchString = text;
        this.filter.q = this.searchString;
        if (!this.searchString && this.$refs.select.open) {
          this.products = [...this.productsDefault];
          // this.filterDefault.page = 1
          loading(false);
          await this.$nextTick();
          this.onOpen();
          return;
        } else if (this.searchString.length) {
          this.isInfiniteScroll = false;
          loading(true);
          this.searchDebounce(loading, text, this);
        }
      },
      searchDebounce: _.debounce((loading, text, vm) => {
        if (vm.searchString) {
          vm.getSearchProduct(loading, text);
        }
      }, 500),
      async onOpen() {
        // Check if no search text & options list is open -> call infinite loading
        if (this.hasInfinity) {
          await this.$nextTick();
          this.observer.observe(this.$refs.load);
        }
        if (this.isLast) {
          return;
        }
        if (this.searchString == "" && this.$refs.select.open) {
          this.isInfiniteScroll = true;
        }
      },
      getSearchProduct(loading, text) {
        product
          .searchProduct(this.filter)
          .then((res) => {
            if (res.data.success) {
              this.products = res.data.data;
              if (res.data.data.length > 0) {
                this.checkNodata = false;
              } else {
                this.checkNodata = true;
              }
              loading(false);
            }
          })
          .catch((err) => {
            loading(false);
          });
      },
      onSelectProduct(data) {
        // if (!data) {
        //   this.products = [...this.productsDefault]
        //   return;
        // }
        if (!this.singleSearch) {
          // this.products = [];
          this.productsSearch = this.result ? [...this.result] : [];
          if (this.addFirst) {
            this.productsSearch.unshift(data);
          } else {
            this.productsSearch.push(data);
          }
          this.listProduct = [];

          this.$emit("update:result", this.productsSearch);
        } else {
          this.$emit("update:result", data);
        }
        if (this.isMultiple) {
          this.$emit("update:result", data);
        }
        this.$emit("input", data);
        if (!this.searchString) return;
        this.products = [...this.productsDefault];
        // this.productsSearch = []
      },
      getCurrency() {
        // let loader = this.$loading.show();
        // setting
        //   .getCurrency()
        //   .then(res => {
        //     if (res.data.success) {
        //       this.currency = res.data.data.text.symbol;
        //     }
        //     loader.hide();
        //   })
        //   .catch(err => {
        //     loader.hide();
        //   });

        // this.currency = this.$store && this.$store.getters.symbolCurrency ? this.$store.getters.symbolCurrency : JSON.parse(window.localStorage.getItem("vuex")).app.symbolCurrency
        this.currency =
          this.$store && this.$store.getters.currency
            ? this.$store.getters.currency
            : JSON.parse(window.localStorage.getItem("vuex")).app.currency;
      },
      getProductDefault() {
        let loader = this.$loading.show({
          container: this.$refs.selectcontainer,
          isFullPage: false,
          width: 20,
          height: 20,
          opacity: 0.4,
        });
        product
          .searchProduct(this.filterDefault)
          .then((res) => {
            loader.hide();
            if (res.data.success) {
              this.products = res.data.data.data;
              this.productsDefault = [...res.data.data.data];
            }
          })
          .catch((err) => {
            loader.hide();
          });
      },
      async infiniteScroll([{ isIntersecting, target }]) {
        if (isIntersecting) {
          const boxContainer = target.offsetParent;
          const scrollTop = target.offsetParent.scrollTop;
          this.filterDefault.page += 1;
          // if (this.filterDefault.page === 1) return
          try {
            const { data } = await product.searchProduct(this.filterDefault);
            this.productsDefault.push(...data.data.data);
            this.products.push(...data.data.data);
            this.total = data.data.total;
            if (data.data.data.length < 10) {
              this.isInfiniteScroll = false;
              this.isLast = true;
            }
          } catch (error) {
            console.log("error :>> ", error);
          }
          await this.$nextTick();
          boxContainer.scrollTop = parseInt(scrollTop);
        }
      },
      onClose() {
        // this.filterDefault.page = 1
        if (this.searchString) return;
        // this.products = [...this.productsDefault]

        // this.observer.disconnect();
      },
    },
    mounted() {
      this.observer = new IntersectionObserver(this.infiniteScroll);
      this.getProductDefault();
    },
    created() {
      this.getCurrency();
      // this.initData()
    },
    computed: {
      optionSearch() {
        return this.products;
      },
      hasInfinity() {
        return this.isInfiniteScroll;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .vs--open .vs__open-indicator {
    //remove css transform rotate 180 icon search
    transform: none;
  }
  .dp-contents {
    display: contents;
  }
  .container-option {
    padding: 5px 0;
  }
  .container-option-0 {
    .img {
      object-fit: contain;
    }
    display: flex;
    width: 60px;
    height: 60px;
  }
  .container-option-1 {
    display: flex;
    flex: 7;
    align-items: center;
    white-space: normal;
  }
  .container-option-2 {
    display: flex;
    flex: 2;
    justify-content: flex-end;
    align-items: center;
  }
  .price-sale__custom {
    text-align: right;
    // padding-bottom: 5px;
    line-height: 8px;
  }
  .badge__search {
    background-color: #ccc;
    border-radius: 10px;
    padding: 0 4px;
    border-radius: 10px;
    font-size: 0.8em;
    width: 45px;
  }

  .color-blur {
    color: #969696;
  }
</style>
<style>
  .vs__selected-options > input.vs__search::placeholder {
    color: #ccc !important;
  }
</style>
